import React from 'react';
import isEmpty from 'lodash/isEmpty';
import kebabCase from 'lodash/kebabCase';
import PropTypes from 'prop-types';
import classNames from '~/components/util/classNames';

function CharacterCounter({ max, value }) {
    let current = value && value.length ? value.length : 0;
    
    if(max) {
        return `${current} / ${max}`;
    } else {
        return current;
    }
}

export default function FormTextArea({
    label = '',
    inputClassName = '',
    name = kebabCase(label),
    placeholder = '',
    autoComplete = '',
    value = '',
    error = '',
    rows = 3,
    path = '',
    type = 'text',
    labelClassName = '',
    groupClassName = '',
    readOnly = false,
    onChange,
    onBlur,
    validator,
    maxLength,
    minLength,
    showCharacterCount,
    required
}) {
    const hasError = !isEmpty(error);
    const hasErrorClass = hasError ? 'is-invalid' : '';
    const classes = classNames('form-input', inputClassName, hasErrorClass);
    const labelClasses = classNames('form-label', labelClassName);

    return (
        <div className={groupClassName}>
            <label htmlFor={name} className={labelClasses}>{label}{required && ' *'}</label>
            <textarea
                id={name}
                name={name}
                type={type}
                rows={rows}
                className={classes}
                readOnly={readOnly}
                placeholder={placeholder}
                autoComplete={autoComplete}
                maxLength={maxLength}
                minLength={minLength}
                value={value}
                required={required}
                onChange={event => onChange(event.target.value, path)}
                onBlur={event => onBlur(event.target.value, path, validator)}
            />
            {showCharacterCount && (
                <span className="charcount">
                    <CharacterCounter max={maxLength} value={value} />
                </span>
            )}
            <div className="invalid-feedback">{error}</div>
        </div>
    );
}

FormTextArea.propTypes = {
    inputClassName: PropTypes.string,
    label: PropTypes.string,
    labelClassName: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    autoComplete: PropTypes.string,
    value: PropTypes.string,
    error: PropTypes.string,
    type: PropTypes.string,
    classes: PropTypes.string,
    groupClassName: PropTypes.string,
    rows: PropTypes.number,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    validator: PropTypes.func,
    readOnly: PropTypes.bool,
    showCharacterCount: PropTypes.bool,
    minLength: PropTypes.number,
    maxLength: PropTypes.number,
    required: PropTypes.bool,
    path: PropTypes.string,
};